/**
 * From Alex:
 * Do not change the order of the polyfills or they will stop working
 */
import React from "react";

import type { AppProps } from "next/app";

import "@formatjs/intl-datetimeformat/locale-data/en-GB";
import "@formatjs/intl-datetimeformat/polyfill";
import "@formatjs/intl-numberformat/locale-data/en-GB";
import "@formatjs/intl-numberformat/polyfill";
import CookieConsentProvider from "common/providers/cookieConsent/cookieConsentProvider";
import StructuredDataProvider from "common/providers/structuredData/structuredDataProvider";
import WhoAmIProvider from "common/providers/whoAmI/whoAmIProvider";
import FavouritesProvider from "features/favourites/provider/favouritesProvider";
import { QueryClient, QueryClientProvider } from "react-query";
import "styles/application.scss";
import "styles/hotjar.scss";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/grid";
import "swiper/css/navigation";

// suppress useLayoutEffect warnings when running outside a browser
if (typeof window === "undefined") React.useLayoutEffect = React.useEffect; //

const queryClient = new QueryClient();

const Motorpoint = ({ Component, pageProps }: AppProps) => {
    return (
        <CookieConsentProvider>
            <QueryClientProvider client={queryClient}>
                <FavouritesProvider>
                    <WhoAmIProvider>
                        <StructuredDataProvider>
                            <Component {...pageProps} />
                        </StructuredDataProvider>
                    </WhoAmIProvider>
                </FavouritesProvider>
            </QueryClientProvider>
        </CookieConsentProvider>
    );
};

export default Motorpoint;
